const map = {
	"./ar/sport.jpg": 17538,
	"./de/sport.jpg": 90378,
	"./en/sport.jpg": 70162,
	"./fr/sport.jpg": 44591,
	"./it/sport.jpg": 49832,
	"./kh/sport.jpg": 4494,
	"./krt/sport.jpg": 82708,
	"./nl/sport.jpg": 66061,
	"./tr/sport.jpg": 42721
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23908;